import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';

@Component({ name: 'Position' })
export default class Position extends Vue {
  @Prop()
  private value!: number | undefined;

  // 职务
  private position: number | undefined | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.position = this.value;
    }

    this.options = await DictApi.getPosition();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    this.position = val;
  }

  public onValidator(): boolean {
    if (this.position === undefined || this.position === null) {
      this.errorMsg = '请选择职务';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeRegistration(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="职务"
        errorMessage={this.errorMsg}
        >
        <SelectInput
          v-model={this.position}
          title="选择职务"
          placeholder="选择职务"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeRegistration}
        />
      </Field>
    );
  }
}
